const sortDates = (dates, reverse = false) => {
	dates.sort((a, b) => b.dates.end_date - a.dates.end_date);
	reverse && dates.reverse();
};

const buildRepeatableEvents = (events, currentTimestamp) => {
	events.forEach((event) => {
		// if the there are multiple dates in event.date array check if one of the dates is in the future if yes set this start and end timestamp as new date array
		if (event.repeating) {
			for (const element of event.repeating) {
				// if there is a date in the future set this as new date array
				if (element.end_date > currentTimestamp) {
					// set the new date array
					event.dates = { start_date: element.start_date, end_date: element.end_date };

					// Set the links for the event
					event.links = element.links;

					// stop the loop if a date is found
					break;
				} else {
					// Set the last date as the date array
					event.dates = element;

					// Set the links for the event
					event.links = element.links;
				}
			}
		}
	});

	return events;
};

const removeAlwaysAvailableEvents = (events) => {
	return events.filter((event) => {
		return event.dates.start_date !== null && event.dates.end_date !== null;
	});
};

const filterEvents = (timeFilter, events) => {
	const currentTimestamp = Math.floor(Date.now() / 1000);

	switch (timeFilter) {
		case 'upcoming_events':
			// Remove always available events from the list.
			events = removeAlwaysAvailableEvents(events);

			// Build the repeating events.
			events = buildRepeatableEvents(events, currentTimestamp);

			// Get all upcoming events with the same category filtered by the API.
			events = events.filter((event) => event.dates.end_date > currentTimestamp);

			// Sort the most recent events to display first.
			sortDates(events, true);

			return events;
		case 'past_events':
			// Remove always available events from the list.
			events = removeAlwaysAvailableEvents(events);

			// Build the repeating events.
			events = buildRepeatableEvents(events, currentTimestamp);

			// Provides events that took place in the past.
			events = events.filter((event) => event.dates.end_date < currentTimestamp);

			// Sorts the past events in descending order, according to when they were held.
			sortDates(events);

			// Reduce the amount of past events to a maximum of 20.
			events = events.slice(0, 20);

			return events;
		case 'always_available_events':
			// Reduce the amount of past events to a maximum of 20.
			events = events.slice(0, 20);

			// Return all events.
			return events;
	}
};

export { buildRepeatableEvents, filterEvents, removeAlwaysAvailableEvents, sortDates };
